import moment from "moment";

/**
 * Owner 2026-10-22: a subtask can't be due after its work item. Compared by calendar day in the
 * browser's time zone (the server refuses dates a full day or more later, with the same sentence).
 * null = fine.
 */
export const subtaskDueProblem = (
  subtaskDue?: string | Date | null,
  workDue?: string | Date | null,
): string | null => {
  if (!subtaskDue || !workDue) return null;
  const sub = moment(subtaskDue);
  const work = moment(workDue);
  if (!sub.isValid() || !work.isValid()) return null;
  return sub.isAfter(work, "day")
    ? `A subtask can't be due after its work item (due ${work.format(
        "MMM D, YYYY",
      )}).`
    : null;
};
